import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import BaseMediaPlayerPage from '@ts-core/pages/BaseMediaPlayerPage';

import { useVideo, useVideos, useMediaSession } from 'modules/media/hooks';

const MediaPlayerPage = () => {
  const { courseId, subjectId, mediaId } = useParams();
  const history = useHistory();

  const {
    videos,
    loading: loadingAllVideos,
    error: allVideosError,
  } = useVideos({
    courseId,
    subjectId,
  });

  const { onMediaPlay, onMediaTimeUpdate, onMediaSeeked, onMediaEnded } = useMediaSession({
    courseId,
    subjectId,
    mediaItemId: mediaId,
  });

  const { video, loading, error } = useVideo({
    courseId,
    subjectId,
    videoId: mediaId,
  });

  const handleSelectMediaItem = useCallback(
    (mediaItem) => {
      history.push(mediaItem._id);
    },
    [history]
  );

  const onGoBack = useCallback(() => {
    history.push(`/${courseId}/subjects/${subjectId}/media`);
  }, [history, courseId, subjectId]);

  return (
    <BaseMediaPlayerPage
      mediaItems={videos}
      loadingMediaItems={loadingAllVideos}
      allMediaItemsError={allVideosError}
      selectedMediaItem={video}
      loadingSelectedMediaItem={loading}
      selectedMediaItemError={error}
      onSelectMediaItem={handleSelectMediaItem}
      onGoBack={onGoBack}
      trackSession
      onMediaPlay={onMediaPlay}
      onMediaTimeUpdate={onMediaTimeUpdate}
      onMediaSeeked={onMediaSeeked}
      onMediaEnded={onMediaEnded}
    />
  );
};

export default MediaPlayerPage;
